export const clearLocalStoragePreservingKeys = (storage, keysToPreserve) => {
  const snapshots = {};

  keysToPreserve.forEach((key) => {
    try {
      const value = storage.getItem(key);
      if (value !== null) {
        snapshots[key] = value;
      }
    } catch (_) {
      // Redirect and logout flows should continue even when storage is blocked.
    }
  });

  storage.clear();

  Object.entries(snapshots).forEach(([key, value]) => {
    try {
      storage.setItem(key, value);
    } catch (_) {
      // Redirect and logout flows should continue even when storage is blocked.
    }
  });
};
